import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { memo } from "react";
import { Link as RouterLink } from "react-router-dom";

import AppIcon from "@/components/Core/AppIcon";
import { MascotBadge } from "@/components/Others/MascotPanel";
import { routers } from "@/configs";
import { useTranslate } from "@/hooks";

import { GreeterEyebrow, GreeterMascot, GreeterRoot } from "./styles";

/**
 * The mascot at the head of the footer.
 *
 * Also the one fixed way to his page: `/mascot` has no menu entry of its own
 * unless an admin adds one.
 */
export const MascotGreeter = memo(() => {
  const translate = useTranslate();

  return (
    <GreeterRoot>
      <GreeterMascot>
        <MascotBadge crowned />
      </GreeterMascot>

      <Stack sx={{ flex: 1, minWidth: 0, gap: 0.5 }}>
        <GreeterEyebrow component="span">{translate("mascot.eyebrow")}</GreeterEyebrow>
        <Typography variant="h5" component="p" sx={{ fontWeight: 800 }}>
          {translate("mascot.cta-title")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {translate("mascot.cta-desc")}
        </Typography>
      </Stack>

      <Button
        component={RouterLink}
        to={routers.Mascot}
        variant="outlined"
        endIcon={<AppIcon name="right2" />}
        sx={{ flexShrink: 0 }}
      >
        {translate("footer.meet-mascot")}
      </Button>
    </GreeterRoot>
  );
});
MascotGreeter.displayName = "MascotGreeter";
